import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hostname } from "../../data";
import { makeRequest } from "../../api/api";


// Async thunk to fetch the data from the API
export const fetchPoolingMetrics = createAsyncThunk(
  'vesselDetails/fetchPoolingMetrics',
  async (params, { rejectWithValue }) => {  
    
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value != null) 
    );

    const  queryString = "?" + new URLSearchParams(filteredParams).toString();
    

    // Use the query string in the request URL
    const request = await makeRequest("get", `v2/pooling/fetch_pooling_dashboard_metrics/${queryString}`);
    const response = request.data;
    return response;
  
  }
);

export const fetchVesselDetailsTable = createAsyncThunk(
  'vesselDetails/fetchVesselDetailsTable',
  async (params, { rejectWithValue }) => {  

    const  queryString = new URLSearchParams(params).toString();
    

    // Use the query string in the request URL
    const request = await makeRequest("get", `v2/pooling/fetch_pool_vessels/?${queryString}`);
    const response = request.data;
    return response;
    
  }
);


export const deleteVesselwithTokenId = createAsyncThunk(
  'vesselDetails/deleteVesselwithTokenId',
  async (payload, { rejectWithValue }) => {  
    // Use the query string in the request URL
    const request = await makeRequest("post", `v2/pooling/delete_pool_vessel/`,payload);
    const response = request.data;
    return response;
    
  }
);

export const getVesselDetailsFilterList = createAsyncThunk(
  'vesselDetails/getVesselDetailsFilterList',
  async (_, { rejectWithValue }) => {  
    // Use the query string in the request URL
    const request = await makeRequest("get", `v2/pooling/vessel_details_filter_list/`);
    const response = request.data;
    return response;
    
  }
);



// Initial state for the slice
const initialState = {
  metrics: {},
  loading: false,
  error: null,
  vesselDetailsTableData:[],
  vesselDetailsTableFilterDataLists:[],
};

// Create the slice
const vesselDetailsSlice = createSlice({
  name: 'vesselDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteVesselwithTokenId.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVesselwithTokenId.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteVesselwithTokenId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;  // Set error message properly
      })
      .addCase(getVesselDetailsFilterList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVesselDetailsFilterList.fulfilled, (state, action) => {
        state.loading = false;
        state.vesselDetailsTableFilterDataLists = action.payload.data; 
      })
      .addCase(getVesselDetailsFilterList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchPoolingMetrics.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPoolingMetrics.fulfilled, (state, action) => {
        state.loading = false;
        state.metrics = action.payload.data;  // Save the response data to state
      })
      .addCase(fetchPoolingMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;  // Set error message properly
      })
      .addCase(fetchVesselDetailsTable.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVesselDetailsTable.fulfilled, (state, action) => {
        state.loading = false;
        state.vesselDetailsTableData = action.payload.data; 
        state.error = "";  // Set error message properly
         // Save the response data to state
      })
      .addCase(fetchVesselDetailsTable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;  // Set error message properly
      });
  }
});

export default vesselDetailsSlice.reducer;
